import React from 'react';
import PropTypes from 'prop-types';
import { getGradeTitle } from '../../../../constants/shared/GradesConstants';

const MeasureWithStudentPrintInfo = ({
    measure,
    student,
    grade,
    titleClassName,
    getMeasureTitle,
    wrapperClassName,
}) => {
    const { measureTitle, measureName } = getMeasureTitle(measure);
    return (
        <div className={wrapperClassName}>
            <div className="student-printing-info">
                <span className="student-name-printing">
                    Student: {student.firstName} {student.lastName}
                </span>
                <span className="grade-printing">{getGradeTitle(grade)}</span>
            </div>
            <div className={`measure-data-title ${titleClassName}`}>
                <div className="measure-label">{measureTitle}</div>
                <div className="measure-name">{measureName}</div>
            </div>
        </div>
    );
};

MeasureWithStudentPrintInfo.defaultProps = {
    measure: '',
    student: {},
    grade: '',
    titleClassName: '',
    getMeasureTitle: () => {},
    wrapperClassName: '',
};

MeasureWithStudentPrintInfo.propTypes = {
    measure: PropTypes.string,
    student: PropTypes.object,
    grade: PropTypes.string,
    titleClassName: PropTypes.string,
    getMeasureTitle: PropTypes.func,
    wrapperClassName: PropTypes.string,
};

export default MeasureWithStudentPrintInfo;
